import { type ReactNode } from 'react';

import { DisplayNamesLastFirstContext } from '@apps/web/context/display_names_last_first_context';
import { useOrganization } from '@apps/web/swr_data_fetching/data_fetching_hooks';

export function DisplayNamesLastFirstProvider({
    organizationId,
    children,
}: {
    readonly organizationId: string | null;
    readonly children: ReactNode;
}) {
    const { data: organization } = useOrganization(organizationId, {
        reason: 'person-name-format',
    });
    const value =
        organization?.general_settings?.display_caregiver_names_last_first ??
        false;
    return (
        <DisplayNamesLastFirstContext.Provider value={value}>
            {children}
        </DisplayNamesLastFirstContext.Provider>
    );
}
